
const config = {
    serverLink: process.env.REACT_APP_API_URL,
    clientLink: process.env.REACT_APP_APP_URL,
    mail3Server: process.env.REACT_APP_MAIL3_SERVER_URL,
    mixpanel: '1c349a5a3539603d1aff3652ab382810',
}

export default config
